import { Extension } from '@tiptap/core';
import { Plugin } from '@tiptap/pm/state';

export const characterLimit = (limit: number) =>
  Extension.create({
    name: 'characterLimit',

    addProseMirrorPlugins() {
      return [
        new Plugin({
          filterTransaction: (transaction, state) => {
            if (!transaction.docChanged) return true;

            const next = transaction.doc.textContent.length;

            // Content already over the limit must still be editable down to it, so a transaction
            // that shortens the document is allowed even while it stays above the limit.
            return next <= limit || next < state.doc.textContent.length;
          },
        }),
      ];
    },
  });
